import { BaseService } from './../../../core/services/base.service';
import { FormBuilder, Validators } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OiGroupDialogData, OiGroupProcessDialogComponent } from 'src/app/shared/oi-group-process-dialog/oi-group-process-dialog.component';
import { NotificationService } from '@optsolservices/ngx-notification';

@Component({
  selector: 'app-sales-order-header-dialog',
  templateUrl: './sales-order-header-dialog.component.html',
  styleUrls: ['./sales-order-header-dialog.component.scss']
})
export class SalesOrderHeaderDialogComponent implements OnInit {
  form: FormGroup;
  salespersons: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<SalesOrderHeaderDialogComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private baseService: BaseService,
    private notificationService: NotificationService,
    private dialog: MatDialog,
  ) {
    this.form = fb.group({
      salesOrderHeaderId: [null, Validators.compose([])],
      salesOrderNumber: [null, Validators.compose([])],
      orderReference: [null, Validators.compose([])],
      orderVersion: [null, Validators.compose([])],
      storeName: [null, Validators.compose([])],
      salespersonCode: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.form.patchValue(this.data);
    this.form.controls['salesOrderHeaderId'].disable();
    this.form.controls['orderReference'].disable();
    this.form.controls['orderVersion'].disable();
    this.form.controls['storeName'].disable();

    if (this.data.mode === 'SYSPRO') {
      this.baseService.executeCommand<any[]>('portal_syspro_order_header_details_dialog_config', this.data)
        .subscribe(response => {
          if (response.responseCode === 0) {
            this.salespersons = response.data;
          }
        });
    } else {
      this.baseService.executeCommand<any[]>('portal_sales_order_header_details_dialog_config', this.data)
        .subscribe(response => {
          if (response.responseCode === 0) {
            this.salespersons = response.data;
          }
        });
    }

  }

  save() {
    if (this.data.mode === 'SYSPRO') {
      const dialogData: OiGroupDialogData = {
        title: 'Updating Sales Person In SYSPRO',
        function: 'portal_oi_group_syspro_order_salesperson_modify',
        postBody: {
          ...this.form.getRawValue()
        }
      };

      const ref = this.dialog.open(OiGroupProcessDialogComponent, {
        data: dialogData,
        width: '450px'
      });

      ref.afterClosed().subscribe(oiResult => {
        if (oiResult.responseCode === 0) {
          this.notificationService.success('Sales Person Updated In Syspro');
          this.dialogRef.close(true);
        }
      });
    } else {
      this.baseService.executeCommand<any[]>('portal_sales_order_header_salesperson_modify', this.form.getRawValue())
        .subscribe(response => {
          if (response.responseCode === 0) {
            this.dialogRef.close(true);
          }
        });
    }
  }
}
